import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Dropdown, List, Spin } from "antd";
import { useCallback, useState } from "react";
import { deleteJobs } from "../../queue/job/deleteJobs.js";
import { retryJobs } from "../../queue/job/retryJobs.js";
import { skipJobs } from "../../queue/job/skipJobs.js";
import { __ } from "../../utils/i18n.js";
const ErrorModalListItem = ({ item: { actions, type, label, description, failedJobs } })=>{
    const [busy, setBusy] = useState(false);
    const handleDelete = useCallback(async ()=>{
        setBusy(true);
        try {
            await deleteJobs({
                type
            });
        } finally{
            setBusy(false);
        }
    }, [
        type
    ]);
    const handleRetry = useCallback(async ()=>{
        setBusy(true);
        try {
            await retryJobs({
                type
            });
        } finally{
            setBusy(false);
        }
    }, [
        type
    ]);
    const handleSkip = useCallback(async ()=>{
        setBusy(true);
        try {
            await skipJobs({
                type
            });
        } finally{
            setBusy(false);
        }
    }, [
        type
    ]);
    const useActionText = useCallback((action, defaultText)=>actions.filter(({ action: a })=>action === a)[0]?.linkText || defaultText, [
        actions
    ]);
    return /*#__PURE__*/ _jsx(Spin, {
        spinning: busy,
        children: /*#__PURE__*/ _jsx(List.Item, {
            style: {
                paddingLeft: 0,
                paddingRight: 0
            },
            actions: [
                /*#__PURE__*/ _jsx(Dropdown.Button, {
                    onClick: handleRetry,
                    menu: {
                        items: [
                            {
                                key: "skip",
                                label: useActionText("skip", __("Skip failed jobs")),
                                onClick: handleSkip
                            },
                            ...actions.map(({ action, url, linkText, target = "_blank" })=>!action && {
                                    key: url,
                                    onClick: ()=>window.open(url, target),
                                    label: linkText
                                }),
                            {
                                key: "delete",
                                danger: true,
                                label: useActionText("delete", __("Cancel process")),
                                onClick: handleDelete
                            }
                        ]
                    },
                    children: useActionText("retry", __("Retry"))
                }, "test")
            ],
            children: /*#__PURE__*/ _jsx(List.Item.Meta, {
                title: label,
                description: /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            children: description
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            style: {
                                marginTop: 10
                            },
                            children: /*#__PURE__*/ _jsx("strong", {
                                children: __("Error message:")
                            })
                        }),
                        failedJobs.slice(0, 1).map((job)=>{
                            const { id, exception: { errors } } = job;
                            return /*#__PURE__*/ _jsx("div", {
                                "data-job": id,
                                onClick: ()=>console.log(job),
                                children: Object.keys(errors).map((code)=>/*#__PURE__*/ _jsx("div", {
                                        "data-code": code,
                                        dangerouslySetInnerHTML: {
                                            __html: errors[code].join("<br />")
                                        }
                                    }, code))
                            }, id);
                        })
                    ]
                })
            })
        })
    });
};
export { ErrorModalListItem };
